
// import axios from 'axios'
import Vue from 'vue'
// import Fuse from 'fuse.js'

const state = {
  ListaSzafy: {},
  ListaAkcesorii: {},
  ListaAkcesoria: {},
  ListaPodzespoly: {}
  // ListaAkumulatory: {},
  // ListaZasilacze: {},
  // ListaListwyD: {},
  // ListaListwyZ: {},
  // ListaMaterialy: {}
}

const getters = {
  ListaSzafy: state => state.ListaSzafy,
  ListaAkcesorii: state => state.ListaAkcesorii,
  ListaAkcesoria: state => state.ListaAkcesoria,
  ListaPodzespoly: state => state.ListaPodzespoly
  // ListaAkumulatory: state => state.ListaAkumulatory,
  // ListaZasilacze: state => state.ListaZasilacze,
  // ListaListwyD: state => state.ListaListwyD,
  // ListaListwyZ: state => state.ListaListwyZ,
  // ListaMaterialy: state => state.ListaMaterialy
}

const mutations = {
  SET_LIST_SZAFY (state, payload) {
    state.ListaSzafy = payload
  },
  SET_LIST_AKCESORII (state, payload) {
    state.ListaAkcesorii = payload
  },
  SET_LIST_AKCESORIA (state, payload) {
    state.ListaAkcesoria = payload
  },
  SET_LIST_PODZESPOLY (state, payload) {
    state.ListaPodzespoly = payload
  },
  CLEAR_LIST_PODZESPOLY (state) {
    state.ListaPodzespoly = {}
  }
  // SET_LIST_AKUMULATORY (state, payload) {
  //   state.ListaAkumulatory = payload
  // },
  // SET_LIST_ZASILACZE (state, payload) {
  //   state.ListaZasilacze = payload
  // },
  // SET_LIST_LISTWY_D (state, payload) {
  //   state.ListaListwyD = payload
  // },
  // SET_LIST_LISTWY_Z (state, payload) {
  //   state.ListaListwyZ = payload
  // },
  // SET_LIST_MATERIALY (state, payload) {
  //   state.ListaMaterialy = payload
  // }
}

const actions = {
  load_all_szafy ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('rack/szafy/' + payload
        // {
          // params: {
          //   lang: paylod
          // }
        // }
        )
          .then(response => response.data).then(results => {
            // console.log(results)
            commit('SET_LIST_SZAFY', results)
            commit('app/SET_LOADING', false, { root: true })
            resolve()
          })
          .catch((err) => {
            console.log(err)
            // reject()
          })
      }, 500)
    })
  },
  load_all_list_akcesoria ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('rack/akcesoria/' + payload)
          .then(response => response.data).then(results => {
            // console.log(results)
            commit('SET_LIST_AKCESORII', results)
            commit('app/SET_LOADING', false, { root: true })
            resolve()
          })
          .catch((err) => {
            console.log(err)
            // reject()
          })
      }, 500)
    })
  },
  load_list_akcesoria ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('rack/akcesoria-dobrane/' + payload[0] + '/' + payload[1] + '/' + payload[2] + '/' + payload[3])
          .then(response => response.data).then(results => {
            // console.log(results)
            commit('SET_LIST_AKCESORIA', results)
            commit('app/SET_LOADING', false, { root: true })
            resolve()
          })
          .catch((err) => {
            console.log(err)
            // reject()
          })
      }, 500)
    })
  },
  load_list_podzespoly ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('rack/podzespoly/' + payload[0] + '/' + payload[1])
          .then(response => response.data).then(results => {
            // console.log(results)
            commit('SET_LIST_PODZESPOLY', results)
            commit('app/SET_LOADING', false, { root: true })
            resolve()
          })
          .catch((err) => {
            console.log(err)
            // reject()
          })
      }, 500)
    })
  },
  get_akcesorium ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // commit('app/SET_LOADING', true, { root: true })
        Vue.axios.get('rack/akcesorium/' + payload[1] + '/' + payload[0]).then(response => {
          resolve(response.data[0])
          // commit('app/SET_LOADING', false, { root: true })
        }, error => {
          reject(error)
        })
      })
    }, 500)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js